function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import * as helpers from "../Base/Helpers";
import PropTypes from 'prop-types';
import classNames from 'classnames';

class TagValue extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onRemove", e => {
      const {
        onRemove,
        tag,
        disabled
      } = this.props;
      e.preventDefault();
      e.stopPropagation();
      if (disabled) return;

      if (onRemove) {
        onRemove({ ...tag,
          value: this.state.value
        });
      }
    });

    _defineProperty(this, "inputRef", c => {
      this._input = c;
    });

    this.state = {
      // editing: false,
      value: props.tag.value
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tag !== this.props.tag) {
      this.setState({
        value: nextProps.tag.value
      });
    }
  }

  render() {
    const {
      itemToString,
      tag,
      disabled
    } = this.props;
    const tagText = helpers.renderItem({
      itemToString,
      item: tag
    });
    const tagRemoveButtonClasses = classNames({
      'autocomplete__tag-remove': true,
      'autocomplete__tag-remove--disabled': disabled
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "autocomplete__tag"
    }, tagText, ' ', /*#__PURE__*/React.createElement("button", {
      className: tagRemoveButtonClasses,
      onClick: this.onRemove
    }, "\u2715"));
  }

}

_defineProperty(TagValue, "propTypes", {
  disabled: PropTypes.bool,
  tag: PropTypes.any,
  itemToString: PropTypes.func,
  onRemove: PropTypes.func
});

export default TagValue;